module.exports = __webpack_public_path__ + "r-v3/img/ml_16_00.eea6b47c.jpg";